import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'

import BuscarCasos from './buscar-casos'
import BandejaCasos from './bandeja-casos'

const EncargadoCompania = () => {
  const [formValues, setFormSubmitValues] = useState()

  const options = { formValues, setFormSubmitValues }
  return (
    <Container>
      <Card className='mt-2'>
        <Card.Header as='h5'>Área de Trabajo</Card.Header>
        <Card.Body>
          
          <BuscarCasos {...options} />
          <BandejaCasos {...options} />
        </Card.Body>
      </Card>
    </Container>
  )
}

export default EncargadoCompania
